module.exports = __webpack_public_path__ + "img/tittle2.6bb5c258.png";